'use strict';
/* eslint no-multi-spaces: 0*/

var ajax = require('../../ajax'),
    tooltip = require('../../tooltip'),
    util = require('../../util'),
    image = require('./image'),
    progress = require('../../progress'),
    tealium = require('../../../../../int_tealium/cartridge/js/tealium/tealium'),
    variant = require('./variant');
const { defineMetadata } = require('core-js/fn/reflect');

function updateSelectWithInvLimit(){
    if($('.custom-inv-data-select').length){
        var updatedInvLimitData = 0;
        $.each($('.custom-inv-data-select'), function () {
            if($(this).find('select option').length <= updatedInvLimitData || updatedInvLimitData === 0){
                $('.inv-to-update').removeClass('inv-to-update');
                updatedInvLimitData = $(this).find('select option').length;
                $(this).addClass('inv-to-update');
            }
        });
        if($('.inv-to-update').length){
            $('.product-add-to-cart.specialProductset .inventory').empty().html($('.inv-to-update').html());
            $('.inv-to-update').removeClass('inv-to-update');
        }
    }
}


module.exports = function () {
    // Initialize jQuery references
    var $allSetButton = $('.all-set-button'),
        $productSetList = $('#product-set-list');

    $("body").off('click', 'button.bh-choose-item-below').on('click', 'button.bh-choose-item-below', function (e) {
        e.preventDefault();
    	var firstChildTop = $('#product-set-list .product-set-item:first').offset().top;
        $('html, body').animate({
            'scrollTop': firstChildTop - 50
        });
    });
    $("body").off('click', '.bh-shipping-return').on('click', '.bh-shipping-return', function (e) {
        e.preventDefault();
        $('.bh-tab-shipping-return-heading').trigger('click');
        $('.bh-tab-shipping-return-heading #shipping-and-returns').focus();
    	var tabTopPos = $('.bh-tab-shipping-return-heading').offset().top;
        $('html, body').animate({
            'scrollTop': tabTopPos - 50
        });
    });
    
    // Update the addToCart buttons
    var updateAddToCartButtons = function () {
        if ($productSetList.find('.add-to-cart-disabled').length > 0) {
            $allSetButton.removeClass('add-all-to-cart');
            $allSetButton.addClass('add-all-to-cart-disabled');
            $('.add-to-cart-disabled').on('click', function (e) {
                e.preventDefault();
                $(this).closest('.product-set-item').find('.variation-selection-error-msg').closest('.attribute').find('.label').hide();
                $(this).closest('.product-set-item').find('.variation-selection-error-msg').show();
                $(this).closest('.product-set-item').find('.variation-selection-error-msg').show();
                return false;
            });
        } else {
            $('.product-set-main-button-error').hide();
            $allSetButton.addClass('add-all-to-cart');
            $allSetButton.removeClass('add-all-to-cart-disabled atb-disabled');
            $('.product-set-product-button-error').hide();
        }
    };

    // Update the productSet mainPrice display
    var updateSetMainPrice = function () {
        // Initialize local variables
        var psproducts = '',
            psproductid = '',
            ajaxUrl;

        // Find the productSet product identifiers for the products in the set
        $('.product-set-list').find('[name="pid"]').each(function () {
            if (psproducts === '') {
                psproducts = $(this).val().trim();
            } else {
                psproducts = psproducts + '|' + $(this).val().trim();
            }
        });

        // Capture the productSet productId and include it in the ajax request
        psproductid = $('#pdpMain').find('.main-product-set-details').data('prodsetid');

        // Append both the variants and the parent productSetId to the url
        ajaxUrl = util.appendParamToURL(Urls.getProductSetPrice, 'pids', psproducts);
        ajaxUrl = util.appendParamToURL(ajaxUrl, 'onchange', 'true');
        ajaxUrl = util.appendParamToURL(ajaxUrl, 'pid', psproductid);
        var globaleCookie = util.getCookie('GlobalE_Data').length ? JSON.parse(decodeURIComponent(util.getCookie('GlobalE_Data'))) : '';
        var globaleCookieCountry = globaleCookie && globaleCookie.countryISO;
        var globaleCookieCurrency = globaleCookie && globaleCookie.currencyCode;    
        ajaxUrl = util.appendParamToURL(ajaxUrl, 'country', typeof globaleCookieCountry !== 'undefined' ? globaleCookieCountry : '');
        ajaxUrl = util.appendParamToURL(ajaxUrl, 'currency', typeof globaleCookieCurrency !== 'undefined' ? globaleCookieCurrency : '');

        // Launch the price request
        ajax.load({
            url: ajaxUrl,
            callback: function (response) {
            	/*SM-6115:	On selecting SKUs of a special product set, its main price range will be varied. 
            	Previously it happens for both product set and special product set.*/
                var $settotalprice = $('.pdp-main.specialproductset').find('.sps-ps-total-price');
                if($settotalprice.length){
                    if($(response).find('.clearance-discount-msg.savingmessage').addBack('.clearance-discount-msg.savingmessage').length && $('.clearance-discount-msg.savingmessage').length){
                        $('.clearance-discount-msg.savingmessage').remove();  // remove already present clearance message if response has it too.
                    }
                    $settotalprice.html('').html(response);
                }
                image.loadZoom();

                // Update the quickView url whenever we update price
                updateQuickViewToProductDetailLink();

                // Update the productSet price-related form-fields
                updateSetPriceFormFields();
            }
        });
    };

    // Update the productSet price form-fields
    var updateSetPriceFormFields = function () {
        // Initialize local variables
        var $SPSPriceContainer;
        var $standardPrice;
        var $salesPrice;
        var $spsForm;
        var standardPriceValue;
        var salesPriceValue;
        var productSetPrices;

        // Exit early if all variants are not selected
        if (areVariantsSelected() === false) { return; }

        // Create a reference to the totalPrice container
        $SPSPriceContainer = $('div.sps-ps-total-price');
        $standardPrice = $SPSPriceContainer.find('span.price-standard');
        $salesPrice = $SPSPriceContainer.find('span.price-sales');

        // Parse-out the standardPrice value
        standardPriceValue = parseSPSPrice($standardPrice);
        salesPriceValue = parseSPSPrice($salesPrice);

        // If no standard-price exists, default it to the sales-price
        if (standardPriceValue === '') { standardPriceValue = salesPriceValue; }

        // Retrieve the productSet item-prices
        productSetPrices = getProductSetPrices();

        // Create a reference to the productSet form display
        $spsForm = $('.product-set-addall').find('.pdpForm');

        // Set the standard / sale prices for the product-set
        $spsForm.find('#spstotalListPrice').val(standardPriceValue);
        $spsForm.find('#spstotalSalesPrice').val(salesPriceValue);

        // Serialize and set the product-price array
        $spsForm.find('#spsChildIdQtyPrices').val(JSON.stringify(productSetPrices));
    };

    var getProductSetPrices = function () {
        // Initialize local variables
        var output;
        var $productSetItems;
        var $productSetItem;
        var $priceContainer;
        var $standardPrice;
        var $salesPrice;
        var productObj;

        // Retrieve each of the product-set items
        $productSetItems = $('#pdpMain #product-set-list div.product-set-details');

        // Default the output array
        output = [];

        // Loop over the collection of productSet items
        for (var pIndex = 0; pIndex < $productSetItems.length; pIndex++) {
            // Set the product property containers
            $productSetItem = $($productSetItems[pIndex]);
            $priceContainer = $productSetItem.find('div.product-price');
            $standardPrice = $priceContainer.find('span.price-standard');
            $salesPrice = $priceContainer.find('span.price-sales');

            // Initialize the productObject
            productObj = {};

            // Seed the product identifier
            productObj.id = $.trim($productSetItem.data('pid'));

            // Seed the standard (list) and sales-price values
            productObj.listPrice = parseSPSPrice($standardPrice);
            productObj.salesPrice = parseSPSPrice($salesPrice);

            // Append this product to the output array
            output.push(productObj);
        }

        // Return the output array
        return output;
    };

    var parseSPSPrice = function ($priceContainer) {
        // Initialize local variables
        var priceValue;

        // Parse-out the price value
        priceValue = $priceContainer.text();
        priceValue = $.trim(priceValue);

        // Parse out the dollar-sign from the price value
        priceValue = priceValue.replace(/\$/g, '');

        // Return the price value (parse and fix it)
        return priceValue;
    };

    var areVariantsSelected = function () {
        // Initialize local variables
        var $productSetDetails;
        var $thisProduct;
        var isVariant;

        // Default the output / tracking variables
        isVariant = true;

        // Retrieve the collection of productSet details
        $productSetDetails = $('.product-set-details');

        // Loop over the collection of set-details, and evaluate the product-type
        for (var pIndex = 0; pIndex < $productSetDetails.length; pIndex++) {
            $thisProduct = $($productSetDetails[pIndex]);
            if ($thisProduct.data('isvariant') === 'false') {
                isVariant = false;
                break;
            }
        }

        // Return the isVariant flag
        return isVariant;
    };

    var triggerTealiumEventSPSColorSelect = function (obj) {
        if (obj) {
            // we are going to override product_id and product_item_id because they are the variation group ids for the 
            // sps component products by default, and analytically we care more about the sets than the variation group details
            obj.product_id = [];
            obj.product_item_id = [];
            obj.product_viewtype = [];
            obj.mini_sps_id = [];
            obj.uber_sps_id = [];
            obj.outlet_status = [];
            obj.event_name = 'sps';
            var pids = $("input[name='pid']", ".product-set-item");
            var mpids = $("input[name='mpid']", ".product-set-item");
            for (var i=0; i < pids.length; i++) {
                if ($.isNumeric($(pids[i]).val())) {
                    obj.product_id.push($(pids[i]).val());
                }
                else {
                    obj.product_id.push($(mpids[i]).val());
                }
                // even though we technically know the mainframeid for the products
                // for color selection I was asked to just push empty strings on pdp view
                obj.product_item_id.push("");
                //obj.product_item_id.push($($(".product-set-item")[i]).data("mainframeid"));
                obj.product_viewtype.push("standard");
                obj.mini_sps_id.push($("input[name='pid']", ".pdpForm").val());
                obj.uber_sps_id.push($("input[name='uberSetId']", ".pdpForm").val());
                obj.outlet_status.push("");
            }

            tealium.triggerViewEvent(obj);
        }
    }

    // Triggering Tealium Event after loading product set variations or product set on PDP.
    var triggerTealiumEvent = function (obj) {

        var prodID = '', collectionID = '';
        if(obj){
            obj.collection_id = [];
            obj.mini_sps_id = [];
            obj.uber_sps_id = [];
            obj.mini_sps_id.push("");
            obj.uber_sps_id.push("");
            obj.event_name = "product_interaction";
            obj.product_viewtype = "standard";
            obj.product_item_id = $('.product-variation-content').data('mainframeid');
            if( $('.pdp-main').hasClass('specialproductset') ){
                prodID = $('.product-detail').data('prodsetid');
                collectionID = "specialproductset_"+prodID;
                obj.collection_id.push(collectionID);
            }if( $('.pdp-main').hasClass('standardproductset') ){
                prodID = $('.product-detail').data('prodsetid');
                collectionID = "coll_"+prodID;
                obj.collection_id.push(collectionID);
            }

            var pids = $("input[name='pid']", ".product-set-item");
            var mpids = $("input[name='mpid']", ".product-set-item");
            if (pids.length > 1 && $('#pdpMain').find('.main-product-set-details').data('containsvariationgroups') === true) {
                obj.product_id = [];
                obj.mini_sps_id = [];
                obj.uber_sps_id = [];
                obj.product_item_id = [];
                obj.product_viewtype = [];
                for (var i=0; i < pids.length; i++) {
                    if ($.isNumeric($(pids[i]).val())) {
                        obj.product_id.push($(pids[i]).val());
                    }
                    else {
                        obj.product_id.push($(mpids[i]).val());
                    }

                    obj.product_item_id.push($($(".product-set-item")[i]).data("mainframeid"));
                    obj.product_viewtype.push("standard");
                    obj.mini_sps_id.push($("input[name='pid']", ".pdpForm").val());
                    obj.uber_sps_id.push($("input[name='uberSetId']", ".pdpForm").val());
                }
            }

            tealium.triggerEvent(obj);
        }
    };

    // Update the quickView product-detail link
    var updateQuickViewToProductDetailLink = function () {
        // Initialize local variables
        var $detailUrls;            // Represents the jQuery reference to the hidden detailUrl links to each psProduct
        var $thisUrl;               // Represents the current productDetail url link for a given psProduct
        var $qvToPDPLink;           // Represents the quickView to productDetail url link for a given psProduct
        var thisHref;               // Temporary variable representing the current url being processed
        var thisHrefArray;          // Temporary variable representing the split url (base from query string)
        var pidsString;             // Temporary variable representing the collection of selected productSet productId's
        var pdpUrl;                 // Represents the compiled qv to productDetail url for this productSet
        var pdpQueryString;         // Represents the complied queryString containing all selected productVariationAttribute / value pairs
        var thisPIDString;          // Represents the derived productID for a given psProduct
        var thisQueryString;        // Temporary variable representing the queryString of a given psProduct product-detail link
        var thisQSArray;            // Temporary variable that splits the psProduct's queryString
        var qsProperties;           // Object used to track unique key / value query string properties across all psProducts
        var finalPDPQueryString;    // Represents the 'final' query string to be attached to the qv2pdp-link
        var thisKVString;           // Represents a given key / value pair from the original productSet's detail link
        var thisKVArray;            // Represents the collection of key / value pairs found in the productSet's detail link
        var pdpHrefArray;           // Represents the '?' split array started from the productSet's detail link
        var pdpBaseUrl;             // Represents the base url for the productSet's detail link (everything to the left of the '?')

        // Default the pdpUrl properties
        pdpUrl = '';
        pdpQueryString = '';
        pidsString = '';
        finalPDPQueryString = '';
        qsProperties = {};

        // Create a reference to the existing PDP Link
        $qvToPDPLink = $('.qv2pdp-link');

        // Exit early if we can't find the PDP link
        if ($qvToPDPLink.length === 0) { return; }

        // Retrieve all of the variationUrls
        $detailUrls = $('.detail-variation-url');

        // Loop over the collection of productDetailUrls found on the page
        for (var urlIndex = 0; urlIndex < $detailUrls.length; urlIndex++) {
            // Create a reference to the current Url
            $thisUrl = $($detailUrls[urlIndex]);

            // Pull the HREF from the url
            thisHref = $thisUrl.data('href');

            // Split the url at the ? (splitting the base from the queryString)
            thisHrefArray = thisHref.split('?');
            thisQueryString = thisHrefArray[1];

            // Split the baseUrl to get the last element in the baseUrl (represents the product)
            thisPIDString = $thisUrl.data('pspid');

            // Append the individual PSP productIDs
            if (pidsString.length > 0) {
                pidsString = pidsString + '|' + thisPIDString.toString();
            } else {
                pidsString = thisPIDString.toString();
            }

            // Only evaluate url properties if they actually exist
            if (thisHrefArray.length > 1) {
                // Append the query string properties to the PDP url
                if (pdpQueryString.length > 0) {
                    pdpQueryString = pdpQueryString + '&' + thisQueryString;
                } else {
                    pdpQueryString = thisQueryString;
                }
            }
        }

        // Pull the URL from the link and split the base from the query parameters
        pdpHrefArray = $qvToPDPLink.data('baseurl').split('?');

        // Seed the baseUrl for the PDP link
        pdpBaseUrl = pdpHrefArray[0];

        if (pdpHrefArray.length > 1) {
            // Append the pdp detail-link query parameters to the baseUrl
            pdpQueryString = pdpQueryString + '&' + pdpHrefArray[1];
        }

        // Consolidate the query string properties and de-dupe any properties
        thisQSArray = pdpQueryString.split('&');

        // Loop over the initial version of the constructed query string
        for (var pIndex = 0; pIndex < thisQSArray.length; pIndex++) {
            // Create a reference to the current qs element
            thisKVString = thisQSArray[pIndex];

            if (thisKVString !== undefined) {
                // Split the element into the key and value
                thisKVArray = thisKVString.split('=');

                // Is this key in the collection of unique properties?
                if (!qsProperties.hasOwnProperty(thisKVArray[0])) {
                    // If not, we can process it (track that its been processed)
                    qsProperties[thisKVArray[0]] = thisKVArray[1];

                    // Append the key value string to the "final" queryString
                    if (finalPDPQueryString.length > 0) {
                        finalPDPQueryString = finalPDPQueryString + '&' + thisKVString;
                    } else {
                        finalPDPQueryString = thisKVString;
                    }
                }
            }
        }

        // Build out the PDP Url (concatenate the productSet products and properties
        pdpUrl = pdpBaseUrl + '?pids=' + pidsString + '&' + finalPDPQueryString;

        // Seed the quickView to PDP transition link with the updated URL value
        $qvToPDPLink.prop('href', pdpUrl);
    };
    
    // Update the availability status for this productSet
    var updateSPSAvailalityStatus = function () {
        if ($('#pdpMain.specialproductset').length  === 0) { return; }

        // Initialize local variables
        var childPids = '';
        var childQtys = '';
        var quantity = $('.specialProductset').find('.quantityinput :selected').val();

        // Loop over the collection of pid-input fields and set the PID / Quantity properties
        $('.product-set-item ').find('input[name="pid"]').each(function (index, value) {
            if (childPids !== '') {
                childPids = childPids + ',' + $(this).val();
                childQtys = childQtys + ',' + quantity;
            } else {
                childPids = $(this).val();
                childQtys = quantity;
            }
        });

        // Update the child productSet properties
        $('input[name="childPids"]').val(childPids);
        $('input[name="childQtys"]').val(childQtys);
        
        $('input[name="spsUUID"]').val(childPids.replace(/,/g,''));

        // Serialize the productSet form properties
        var $form = $('.product-set-addall').find('.pdpForm');

        ajax.getJson({
            url: util.ajaxUrl(Urls.specialProductSetATS),
            data: $form.serialize(),
            callback: function (response) {
                var responseObj = response != null ? JSON.parse(response.error) : '';
                if (responseObj !== '') {
                    $('.availability-novariation').addClass(responseObj.availabilityClass);
                    $('.availability-novariation').html(responseObj.availabilityMsg);
                    if (Number(responseObj.maxAvailableATS) < Number(quantity)) {
                        return false;
                    }
                }
            }
        });
    };

    // Update the quickView thumbnail image to reflect the selected product-image
    var selectProductSetQuickViewThumbnail = function () {
        // Initialize local variables
        var $activeProduct;
        var $activeSwatch;
        var $thumbImage;
        var $colors;
        var psItemIDValue;
        var psItemID;
        var dataSwatch;
        var thumbClass;

        // Exit early if this is not a standard product-set
        if (!$('#pdpMain').hasClass('standardproductset')) { return; }

        // Determine the active / visible product
        $activeProduct = $('div.product-set-item.selected');
        psItemIDValue = $activeProduct.attr('id');
        psItemID = psItemIDValue.split('-')[1];

        // Get the active swatch for the active product
        $colors = $activeProduct.find('ul.swatches.color');
        $activeSwatch = $colors.find('li.selected');
        dataSwatch = $activeSwatch.find('a.color').data('lgimg');

        // Create a reference to the active thumb-image
        thumbClass = '.thumb-' + psItemID;
        $thumbImage = $(thumbClass);

        // Update the display properties of the thumbnail image
        $thumbImage.data('lgimg', dataSwatch);
        $thumbImage.attr('src', dataSwatch.tile);
        $thumbImage.attr('alt', dataSwatch.alt);
        $thumbImage.attr('title', dataSwatch.title);
    };

    // Update and default the addToCart button display
    if ($productSetList.length > 0) {
        updateAddToCartButtons();
    }
    //Initialize the collapse/expand using css add handing click using js-class
    $productSetList.on('keydown click',function (e) {
        try {
            $header = $(this);
            //getting the next element
            $content = $header.next();
            //open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
            $content.slideToggle(500, function () {
                //execute this after slideToggle is done
                //change text of header based on visibility of content div
                $header.text(function () {
                    //change text based on condition
                    return $content.is(":visible") ? "Collapse" : "Expand";
                });
            });
        }
        catch(e) {}    
    });
    
    //Update Price & availabilty when quantity is changed
    $('.specialProductset').on('change', '.quantityinput', function (e) {
        updateSetMainPrice();
        updateSPSAvailalityStatus();
        updateAddToCartButtons();
        
        var $curObj = $('.all-set-button');
        var productSetItem = $('.product-set-item');
        var colorSelectedLength = productSetItem.find(".swatches.color li.selectable.selected").length;
        var topSizeSelectedLength = productSetItem.find(".sps_top_size li.selectable.selected").length;
        var bottomSizeSelectedLength = productSetItem.find(".sps_bottom_size li.selectable.selected").length;
    
        if($('#pdpMain').hasClass('sw-specialproductset')){
            if( colorSelectedLength && topSizeSelectedLength && bottomSizeSelectedLength){
                $curObj.attr("aria-disabled","false").removeClass('atb-disabled');
            }else if( (colorSelectedLength == 0) && topSizeSelectedLength && bottomSizeSelectedLength ) {
                    $curObj.html(Resources.SPS_TOP_COLOR).attr("aria-disabled","true").addClass('atb-disabled');
            }else if(colorSelectedLength && (topSizeSelectedLength == 0) && bottomSizeSelectedLength){
                    $curObj.html(Resources.SPS_TOP_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
            }else if(colorSelectedLength && topSizeSelectedLength && (bottomSizeSelectedLength == 0)){
                    $curObj.html(Resources.SPS_BOTTOM_SIZE).attr("aria-disabled","true").addClass('atb-disabled'); 
            }else if((colorSelectedLength == 0) && (topSizeSelectedLength == 0) && bottomSizeSelectedLength){
                $curObj.html(Resources.SPS_TOP_COLOR_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
            }else if((colorSelectedLength == 0) && topSizeSelectedLength && (bottomSizeSelectedLength == 0)){
                $curObj.html(Resources.SPS_TOP_COLOR_BOTTOM_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
            }else if(colorSelectedLength && (topSizeSelectedLength == 0) && (bottomSizeSelectedLength == 0)){
                $curObj.html(Resources.SPS_TOPBOTTOM_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
            }else if((colorSelectedLength == 0) && (topSizeSelectedLength == 0) && (bottomSizeSelectedLength == 0)){
                    $curObj.html(Resources.SPS_TOPBOTTOM_COLOR_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
            }    
        }
    });
    
    // click on swatch for product set
    $productSetList.on('keydown click ', '.product-set-item .swatchanchor', function (e) {
        
    	   if(e.type === "keydown"){
               if (e.keyCode !== 13) return;
           }
        e.preventDefault();
        var origLargeImg;
        if($(this).data('origlgimg') != undefined){
            origLargeImg = JSON.parse($(this).data('origlgimg'));
        }
        // per SM-2901, disable the ability to deselect a swatch
        if ($(this).closest('li').hasClass('selected')) {
            return;
        }
     
        // Default local variables
        var url;                    // Describes the url used to retrieve a productSet item
        var variantUrl;
        var variantQueryString;
        var productSetID;           // Represents the productID for the parent productSet
        var $container;             // Represents the HTML container for the productSet item
        var qty;                    // Represents the quantity selected
        var variantType=$(this).data('swatchtype');
        var isBottomItem=$(this).data('isbottomitem');
        var swatchData=$(this).data('swatch'); 

        var containsVariationGroups=$('#pdpMain').find('.main-product-set-details').data('containsvariationgroups');
        var selectedSwitchID = $(this).data('swatchid');
        var productVariationsID = $(this).closest('.product-variations').attr('data-mpid');
        if ($(this).hasClass("color") && containsVariationGroups === true) {
            //e.stopPropagation();
            //location.href = $(this).data('href');
            var $spsSetUrl = $(this).data('href');
            // add format=ajax parameter if it isn't on the sps set url
            if ($spsSetUrl.indexOf("format=ajax") === -1) {
                if ($spsSetUrl.indexOf("?") > -1) {
                    $spsSetUrl += "&format=ajax";
                }
                else {
                    $spsSetUrl += "?format=ajax";
                }
            }
            $spsSetUrl += location.hash;
            
            var $main = $('#maincontent');
            // Show the process dialog
            if ($('.ui-dialog').length > 0) {
                // Check if the quickView dialog for a product-set is visible
                if ($('div.product-set-quickview').length > 0) {
                    $('div.product-set-quickview').spinner().start();
                } else {
                    $('#QuickViewDialog').spinner().start();
                }
            } else {
                // Otherwise, default to the desktop view
                $.spinner().start();
            }
            var $desktopRecomm = $('.you-may-like.recommendation.hide-mobile.hide-tablet');
            if($desktopRecomm.length && $desktopRecomm.find(".recommendation-tiles").length && $desktopRecomm.find(".recommendation-tiles").hasClass("slick-initialized")){
            	if($desktopRecomm.find(".recommendation-tiles").find('div.inner-tile').length){
            		util.renameElement($desktopRecomm.find(".recommendation-tiles").find('div.inner-tile'),'li');
                }                
            		$desktopRecomm.find(".recommendation-tiles").slick("unslick");
            }
             
            var recommDataDesktop = $desktopRecomm.length ? $desktopRecomm.html() : '';
             
            var $mobileRecomm = $('.you-may-like.recommendation.hide-desktop');
            if($mobileRecomm.length && $mobileRecomm.find(".recommendation-tiles").length && $mobileRecomm.find(".recommendation-tiles").hasClass("slick-initialized")){
            	if($mobileRecomm.find(".recommendation-tiles").find('div.inner-tile').length){
            		util.renameElement($mobileRecomm.find(".recommendation-tiles").find('div.inner-tile'),'li');
                }               
            		$mobileRecomm.find(".recommendation-tiles").slick("unslick");
            }
             
            var recommDataMobile = $mobileRecomm.length ? $mobileRecomm.html() : '';
            var $turnToTeaser = $('.TTteaser');
            var $turnToProductInfo = $('#tt-product-info');
            ajax.load({
                url: $spsSetUrl,
                target: $main,
                callback: function () {
                    
                	var $updatedcolor= $('.product-set-details').data('spstitle');
                	document.title= $updatedcolor;
                	var product = require('../product');
                    product.initializeEvents();
                    // tealium, trigger product view event
                    var data = $('#pdpMain').data('productinfo');
                    triggerTealiumEventSPSColorSelect(data);
                    $('body').find('.you-may-like.recommendation.hide-mobile.hide-tablet').html($.parseHTML(recommDataDesktop));
                    $('body').find('.you-may-like.recommendation.hide-desktop').html($.parseHTML(recommDataMobile));
                    // Hide the progress window
                    $.spinner().stop();
                    var imagesLoaded = require('imagesloaded');
                    imagesLoaded('.recommendation-tiles').on('always', function() {
                        util.pdpSlickSlider();
                    });
                    util.proset_SlickSlider();
                    util.selectbox();
                    var $reloadedTeaser = $('.TTteaser');
                    if ($reloadedTeaser.length && $turnToTeaser.length) {
                        $reloadedTeaser.replaceWith($turnToTeaser);
                    }

                    var $reloadedProductInfo = $('#tt-product-info');
                    if ($reloadedProductInfo.length && $turnToProductInfo.length) {
                        $reloadedProductInfo.find('.review-section').replaceWith($turnToProductInfo.find('.review-section'));
                        $reloadedProductInfo.find('.qanda-section').replaceWith($turnToProductInfo.find('.qanda-section'));
                    }
                }
            });
        }
        else {
            // Initialize the current url
            url = Urls.getSetItem + (typeof this.search === 'undefined' ? '' : this.search);

            variantUrl = $(this).data('href');
            variantQueryString = variantUrl.split('?')[1];

            // Retrieve the productSet identifier
            productSetID = $('#pdpMain').find('.main-product-set-details').data('prodsetid');

            // Append the productSet id to the url
            url = util.appendParamToURL(url, 'productSetID', productSetID);

            // Append the variation-details to the productSet url
            url += '&' + variantQueryString;

            // Create a reference to the container that will be seeded with the set-item
            $container = $(this).closest('.product-set-item');

            // Retrieve the quantity selected by the user
            qty = $container.find('.quantityinput :selected').val();
            // SM-5221
            var desOpenFlag = $container.find('.product-set-long-description').hasClass('make-height-auto') ? true : false;
            // Show the process dialog
            if ($('.ui-dialog').length > 0) {
                // Check if the quickView dialog for a product-set is visible
                if ($('div.product-set-quickview').length > 0) {
                    $('div.product-set-quickview').spinner().start();
                } else {
                    $('#QuickViewDialog').spinner().start();
                }
            } else {
                // Otherwise, default to the desktop view
                $.spinner().start();
            }
             

            window.swatchTarget = e.target;
            // Load the productSet item
            ajax.load({
                url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
                target: $container,
                callback: function () {
                    $('#pdpMain .swatchanchor img').unveil(0,variant.pdpSwatchLazyLoad);
                    // Create a reference to the all-set button
                    var $specialproductset = $('.pdp-main.specialproductset').find('.all-set-button');
                    $('.pdp-main.standardproductset').find('.all-set-button').html('').html(Resources.ADD_ALLTO_BAG).removeAttr('disabled');

                    // Clear the product-set button-content
                    $specialproductset.html('');

                    // Is this coming from the cart?
                    if (url.indexOf('source=cart') > -1) {
                        $specialproductset.html(Resources.UPDATE).removeAttr('disabled');
                    } else {
                        $specialproductset.html(Resources.ADD_TO_BAG).removeAttr('disabled');
                    }
                    //SC-8920
                    updateSelectWithInvLimit();
                                    
                    // SM-5325
                    if($(window).width() < 768) {
                        if($container.find('ul.swatches li.selected').length > 0) {
                            var $parent = $container;
                            $parent.addClass('product-open');
                            $parent.find('.product-variations, .showmore-hemming-monogramming,.productset-cartbutton,.availability-web').show();
                            $parent.find('.product-variations-toggle').text(Resources.SHOP_NOW_CLOSE);
                        }
                    }
                    var imagesLoaded = require('imagesloaded');
                        imagesLoaded($container).on('always', function() {
                            image.lazyLoadImages($container.find('img'));
                            if (typeof origLargeImg !== 'undefined') {
                                var swatchselected = $container.find('ul.swatches li.selected');
                                if(swatchselected.length > 0){
                                if($(window.swatchTarget).hasClass("color") || $(window.swatchTarget).parent().hasClass("color")){
                                    $(".product-bundle .product-image.main-image img").attr("src", "");                    	   
                                    image.setMainImage(origLargeImg);
                                }
                            }
                        }
                    });
                    // SM-5221
                    if(desOpenFlag) {
                        $container.find('.read-more').text(Resources.READ_LESS).addClass('opened');
                        $container.find(".product-set-long-description").addClass("make-height-auto");
                    } else {
                        util.productSetReadmore();
                    }
                    
                    //init True Fit widget
                    if($('.tfc-fitrec-product').length > 0 && typeof tfcapi === 'function'){
                        tfcapi('calculate');
                    }
                    // Process the updates
                    updateSetMainPrice();
                    updateSPSAvailalityStatus();
                    updateAddToCartButtons();
                    tooltip.init();
                    util.updateselect();
                    
                    // Check if the quickView dialog for a product-set is visible
                    if ($('div.product-set-quickview').length > 0) {
                        selectProductSetQuickViewThumbnail();
                    }

                    // Hide the progress window
                    $.spinner().stop();

                    // Adds scroll after swatch anchor in product set.
                    if (!$('#wrapper').hasClass('pt_product-details')) {
                        if ($('.product-set-item.selected .qv-productset-scrollbar').height() > 430 && !$('#pdpMain').hasClass('specialproductset')) {
                            $('.product-set-item.selected .qv-productset-scrollbar').slimScroll({
                                height: '430px',
                                railVisible: true,
                                color: '#f4f4f4',
                                railColor: '#ffffff',
                                railOpacity: 1,
                                size: '10px',
                                allowPageScroll: false,
                                alwaysVisible: true
                            });
                        }
                    }
                    if(variantType === 'color' && !isBottomItem){
                        loadSPSBottomItemvariations();  
                    }
                    triggerTealiumEvent(swatchData);
                    
                    if(e.keyCode == 13){
                    	 setTimeout(function(){
                         	if( !(productVariationsID === null || productVariationsID === 'null') ){
                         		$('[data-mpid="'+ productVariationsID +'"]').find('[data-swatchid="'+selectedSwitchID+'"]').focus().addClass('focus-outline');
                         	}                    	
                         }, 100);
                   }
                }

            });
        }
    });
    
    // SM-5221
    util.productSetReadmore();
    // SM-3033
    updateSPSAvailalityStatus();
    
    $('#pdpMain').off('click keypress', '.read-more-content .read-more').on('click keypress', '.read-more-content .read-more', function (e) {
    	if(e.type === "keypress"){
            if (e.which !== 13) return;
        }
    	e.preventDefault();
        var $parent = $(this).closest(".product-variations");
        if (!$(this).hasClass('opened')) {
        	$(this).text(Resources.READ_LESS).addClass('opened');
        	$parent.find(".product-set-long-description").removeClass('max-height-limit').addClass("make-height-auto");
        } else {
        	$(this).text(Resources.READ_MORE).removeClass('opened');
        	$parent.find(".product-set-long-description").removeClass("make-height-auto").addClass('max-height-limit');
        }
    });

    var initShowMoreReviewsLinkFor = function (pid){
        var $productReviewsContainer = $('#reviews-' + pid);
        var $allProductReviews = $productReviewsContainer.find('.TTreview');
        var hiddenReviewCount = $allProductReviews.not(':visible').length;

        if(hiddenReviewCount > 0){
            var x = Math.min(hiddenReviewCount,10); 
            $productReviewsContainer.find('.TT3ShowMoreText').attr('data-reviewstoshow',x).text('Show ' + x + ' more reviews');
            return true;
        }
        $productReviewsContainer.find('.TT3ShowMore').hide();
        return false;
    };
    
    var loadSPSBottomItemvariations = function(){
        // Default local variables
        var url;                    // Describes the url used to retrieve a productSet item
        var variantUrl;
        var variantQueryString;
        var productSetID;           // Represents the productID for the parent productSet
        var $container;             // Represents the HTML container for the productSet item
        var qty;                    // Represents the quantity selected
        // Initialize the current url
        url = Urls.getSetItem;

        variantQueryString = $('#bottomItemColorSwatchURL').val();
        if (variantQueryString != undefined && variantQueryString != null && variantQueryString != ''){
              // Retrieve the productSet identifier
		        productSetID = $('#pdpMain').find('.main-product-set-details').data('prodsetid');
		
		        // Append the productSet id to the url
		        url = util.appendParamToURL(url, 'productSetID', productSetID);
		
		        // Append the variation-details to the productSet url
		        url += '&' + variantQueryString;
		
		        // Create a reference to the container that will be seeded with the set-item
		        $container = $('#bottomItemColorSwatchURL').closest('.product-set-item');
		
		        // Retrieve the quantity selected by the user
		        qty = $container.find('.quantityinput :selected').val();
		        // SM-5221
		        var desOpenFlag = $container.find('.product-set-long-description').hasClass('make-height-auto') ? true : false;
		        // Show the process dialog
                if ($('.ui-dialog').length > 0) {
                    // Check if the quickView dialog for a product-set is visible
                    if ($('div.product-set-quickview').length > 0) {
                        $('div.product-set-quickview').spinner().start();
                    } else {
                        $('#QuickViewDialog').spinner().start();
                    }
                } else {
                    // Otherwise, default to the desktop view
                    $.spinner().start();
                }

		        // Load the productSet item
		        ajax.load({
		            url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
		            target: $container,
		            callback: function () {
		                // Create a reference to the all-set button
		                var $specialproductset = $('.pdp-main.specialproductset').find('.all-set-button');
		                $('.pdp-main.standardproductset').find('.all-set-button').html('').html(Resources.ADD_ALLTO_BAG).removeAttr('disabled');
		
		                // Clear the product-set button-content
		                $specialproductset.html('');
		
		                // Is this coming from the cart?
		                if (url.indexOf('source=cart') > -1) {
		                    $specialproductset.html(Resources.UPDATE).removeAttr('disabled');
		                } else {
		                    $specialproductset.html(Resources.ADD_TO_BAG).removeAttr('disabled');
		                }
		                // SM-5325
		                if($(window).width() < 768) {
		                	if($container.find('ul.swatches li.selected').length > 0) {
		                    	var $parent = $container;
		                        $parent.addClass('product-open');
		                		$parent.find('.product-variations, .showmore-hemming-monogramming,.productset-cartbutton,.availability-web').show();
		                		$parent.find('.product-variations-toggle').text(Resources.SHOP_NOW_CLOSE);
		                    }
		                }
		                var imagesLoaded = require('imagesloaded');
			       		imagesLoaded($container).on('always', function() {
			       			image.lazyLoadImages($container.find('img'));
			   		    });
		                // SM-5221
		                if(desOpenFlag) {
		                	$container.find('.read-more').text(Resources.READ_LESS).addClass('opened');
		                	$container.find(".product-set-long-description").addClass("make-height-auto");
		                } else {
		                	util.productSetReadmore();
		                }
		                // Process the updates
		                updateSetMainPrice();
		                updateSPSAvailalityStatus();
		                updateAddToCartButtons();
		                tooltip.init();
		                util.updateselect();
		                
		                // Check if the quickView dialog for a product-set is visible
		                if ($('div.product-set-quickview').length > 0) {
		                    selectProductSetQuickViewThumbnail();
		                }
		
		                // Hide the progress window
		                $.spinner().stop();
		
		                // Adds scroll after swatch anchor in product set.
		                if (!$('#wrapper').hasClass('pt_product-details')) {
		                    if ($('.product-set-item.selected .qv-productset-scrollbar').height() > 430 && !$('#pdpMain').hasClass('specialproductset')) {
		                        $('.product-set-item.selected .qv-productset-scrollbar').slimScroll({
		                            height: '430px',
		                            railVisible: true,
		                            color: '#f4f4f4',
		                            railColor: '#ffffff',
		                            railOpacity: 1,
		                            size: '10px',
		                            allowPageScroll: false,
		                            alwaysVisible: true
		                        });
		                    }
		                }
		            }
		        });
        }
    }

    $(window).on('load', function () {
        /*if ($('.pdp-main.standardproductset').length !== 0) {
            //load review section by ajax in product set page with product set id
            var url = Urls.getProductReviews;
            var pid = $('.main-product-set-details').data('prodsetid');
            var params = {
                'pid' : pid,
                'isUberSetid': $('.pdp-main.sw-specialproductset').length !== 0,
                'format' : 'ajax',
            };
            url = util.appendParamsToUrl(url,params);
            if (pid) {
                $.ajax(url, {
                    success: function (result) {
                        $('#reviews-' + pid).empty().html(result).find('#TurnToReviewsContent')
                            .addClass('review-collapse').after(
                                "<div class='review-collapsed-button'> \
                            <a href='javascript:void(0)'>\
                                <span></span> \
                            </a> \
                            </div>"
                            );

                        var $findclassTTwriteReview = $('.review-main-section .TTreviewSummary .TTwriteReview').not('#TTwriteReviewBtn, #TTwriteReviewBtn-portrait');

                        if (!$('#reviews-' + pid).find('#TurnToReviewsContent').is(':empty')) {
                            $('#reviews-' + pid).closest('.review-main-section').find('.product-name').removeClass('hide');
                        } else {
                            $('#reviews-' + pid).find('.review-collapsed-button').hide();
                        }

                        if ($findclassTTwriteReview.length > 0) {
                            $findclassTTwriteReview.closest('.review-main-section').find('.review-collapsed-button').hide();
                        }

                        $(".review-collapsed-button").find('span').text(Resources.SEE_REVIEWS);
                        TurnTo.initialize();
                        initShowMoreReviewsLinkFor(pid);
                    }
                });
            }
        }*/
        var params = util.getQueryStringParams(window.location.href);
        var cartParam = params.source ? params.source :  '';
        if($('.s-product-set').length && cartParam === 'cart'){
            //SC-8920
            updateSelectWithInvLimit();
            util.updateselect();
        }
        updateSetMainPrice();
        updateSPSAvailalityStatus();
        $('#tt-product-info .tab-content button').addClass('btn-ds');
    });
    
    $('.review-main-section').on('click', '.review-collapsed-button a', function(e) {
    	e.preventDefault();
        var $self = $(this),
            reviewsToShow = window.SitePreferences.PDP_REVIEWS_SHOWN_INITIALLY,
    		$reviewSection = $self.closest('.review-main-section');
    	if ($reviewSection.find('#TurnToReviewsContent').hasClass('review-collapse')) {
    		$reviewSection.find('#TurnToReviewsContent').removeClass('review-collapse');
    		$reviewSection.addClass('review-expanded');
            $self.find('span').text(Resources.SEE_REVIEWS_CLOSE);
            $reviewSection.find('.TTreview:visible').slice(reviewsToShow, $reviewSection.find('.TTreview:visible').length).hide();
    	} else {
    		$reviewSection.find('#TurnToReviewsContent').addClass('review-collapse');
    		$reviewSection.removeClass('review-expanded');
    		$self.find('span').text(Resources.SEE_REVIEWS);
    	}
    }).on('click', '#TTreviewsWrapper .TT3ShowMore a', function(e) {
        e.preventDefault();
        var $self = $(this);
        var $reviewsContainer = $self.closest('.reviews-container');
        var reviewsToShow = $self.find('.TT3ShowMoreText').attr('data-reviewstoshow');
        $reviewsContainer.find('.TTreview').not(':visible').slice(0,reviewsToShow).show();
        initShowMoreReviewsLinkFor($reviewsContainer.attr('data-pid'));
    });
    
    // on click review counts on PDP navigates to review tab section.
    $('body').on('click', '.turntofitcounts, .TTreviewcount', function (e) {

        if ($('.pdp-main.sw-specialproductset').length !== 0 && $('.review-heading.tab-header').length > 0) {
            var $fixedHeader = $('.fixed-header').outerHeight();
            $('html, body').animate({ scrollTop: $('.review-heading.tab-header').offset().top - $fixedHeader }, 700);
            $('.tabs .review-heading').trigger('click');
        }
    });
    
    $('.tabs .tab-header').click(function () {
        var tab_id = $(this).data('tab');
        $('.tabs .tab-header').removeClass('current');
        $('.tab-content').removeClass('current');
        $('.tabs .tab-header').attr('aria-selected','false');
        $(this).addClass('current');
        $('.tabs .tab-header.current').attr('aria-selected','true');
        $("#" + tab_id).addClass('current');
        /*if (tab_id === 'tab-5' || tab_id === 'tab-7') {
            var url = Urls.getProductReviews;
            var targetElement = $('.review-section .tab-content-details');
            var contentLoaded = false;
            var pid = $('.pdp-main.sw-specialproductset').length !== 0 ? $('#uberSetId').val() : $('.main-product-set-details').data('prodsetid');
            
            var params = {
                'pid': pid,
                'isUberSetid': $('.pdp-main.sw-specialproductset').length !== 0,
                'format': 'ajax',
            };

            if (tab_id === 'tab-5') {
                var contentLength = $("#TurnToReviewsContent").html().length;
                if (contentLength > 0) {
                    contentLoaded = true;
                }
                if ($('.review-section .tab-content-details').length !== 0 && $('.review-section .tab-content-details').has($('div')).length === 0) {
                    progress.show($('.review-section .tab-content-details'));
                }
                targetElement = $('.review-section .tab-content-details');
            }
            else if (tab_id == 'tab-7') {
                var contentLength = $("#TurnToContent").html().length;
                if (contentLength > 0) {
                    contentLoaded = true;
                }
                url = Urls.getProductQA;
                if ($('.qanda-section .tab-content-details').length !== 0 && $('.qanda-section .tab-content-details').has($('div')).length === 0) {
                    progress.show($('.qanda-section .tab-content-details'));
                }
                targetElement = $('.qanda-section .tab-content-details');
            }

            url = util.appendParamsToUrl(url, params);

            if (!contentLoaded) {
	            ajax.load({
	                url: url,
	                data: 'pid=' + pid,
	                target: targetElement,
	                callback: function () {
	                    TurnTo.initialize();
	                }
	            })
			}
        };*/
    });
   
};

